import React, { useState, useEffect, useRef } from 'react';

const Search = ({ onSearch, placeholder = "Buscar", className = "input-theme mr-2" }) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [isSearching, setIsSearching] = useState(false);
  const debounceRef = useRef(null);

  useEffect(() => {
    if (debounceRef.current) {
      clearTimeout(debounceRef.current);
    }

    if (searchTerm.trim() === '') {
      setIsSearching(false);
      onSearch('');
      return;
    }

    setIsSearching(true);

    debounceRef.current = setTimeout(() => {
      setIsSearching(false);
      onSearch(searchTerm.trim());
    }, 500);

    return () => {
      if (debounceRef.current) {
        clearTimeout(debounceRef.current);
      }
    };
  }, [searchTerm]);

  const handleChange = (e) => {
    setSearchTerm(e.target.value);
  };

  const handleClear = () => {
    setSearchTerm('');
  };

  return (
    <div className="position-relative">
      <input
        type="text"
        className={className}
        placeholder={placeholder}
        value={searchTerm}
        onChange={handleChange}
      />
      {isSearching && (
        <div className="position-absolute" style={{ right: '10px', top: '50%', transform: 'translateY(-50%)' }}>
          <i className="fas fa-circle-notch fa-spin text-muted"></i>
        </div>
      )}
      {searchTerm && !isSearching && (
        <button
          type="button"
          className="position-absolute btn btn-link p-0"
          style={{ right: '15px', top: '50%', transform: 'translateY(-50%)', border: 'none', background: 'none' }}
          onClick={handleClear}
        >
          <i className="fas fa-times text-muted"></i>
        </button>
      )}
    </div>
  );
};

export default Search; 